<div class="d-flex align-items-center justify-content-between">
    <label class="filterLabelStyle" style="margin: 0 !important; z-index: 9;">{{ label || "Date Range" }}</label>
    <div *ngIf="compulsaryFilterValidation()">
        <span mat-button style="cursor: pointer;font-size: 12px;font-family: 'Poppins';padding: 0 5px;    background: #ddd;
        border-radius: 5px;
        margin: 0 10px;" (click)="clearDateFilter()">Clear</span>
    </div>
</div>

<div class="my-1">
    <mat-form-field appearance="fill" style="width: 100%;" class="du-formly-date-range">
        <mat-label style="font-family: 'Poppins';">Select date range</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate" [max]="(!compulsaryFilter && isRestriction == 'no') ? null : maxDate">
            <input matStartDate readonly formControlName="start" placeholder="Start date">
            <input matEndDate readonly formControlName="end" (dateChange)="endDateChanges()" placeholder="End date">
        </mat-date-range-input>
        <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    
        <mat-error
            *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid
            start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid
            end date</mat-error>
    </mat-form-field>
</div>
<hr>